// extracted by mini-css-extract-plugin
export default {"form":"DeleteDetailModal_form__w4m-w","status":"DeleteDetailModal_status__slA8Z"};